import React from "react";

import { Card, FaIcon, FaIcons, Toggle } from "@in/component-library";

interface AccountCardProps {
  accountId: string;
  name: string;
  displayId: string;
  onSelectAccount: (accountId: string, isExternal: boolean) => void;
  isExternal?: boolean;
  isEditable?: boolean;
  isHidden?: boolean;
  onToggle?: (accountId: string) => void;
  isPersonal?: boolean;
  personal?: string;
  company?: string;
}

const AccountCard = ({
  accountId,
  name,
  displayId,
  onSelectAccount,
  isExternal = false,
  isEditable = false,
  isHidden = false,
  onToggle,
  isPersonal = false,
  personal,
  company
}: AccountCardProps) => (
  <Card
    className="account-card__card"
    onClick={() => {
      !isEditable && onSelectAccount(accountId, isExternal);
    }}
    boxShadow
  >
    {isPersonal ? <FaIcon name={FaIcons.UserLight} /> : <FaIcon name={FaIcons.BuildingLight} />}
    <span className="account-card__info">
      <span className="account-card__name data-hj-suppress">{name}</span>
      <span className="account-card__type">{isPersonal ? personal : company}</span>
      <span className="account-card__display-id">{displayId}</span>
    </span>
    {isEditable ? (
      <Toggle
        value={!isHidden}
        label=""
        onClick={() => {
          onToggle && onToggle(accountId);
        }}
      />
    ) : (
      <FaIcon name={FaIcons.ArrowRight} />
    )}
  </Card>
);

export default AccountCard;
